const pageMap = {
  '/': 'homepage',
  '/hotels': 'landingpage',
  '/flights': 'landingpage',
  '/vacationpackages': 'landingpage',
  '/vip': 'vip'
} as const

type PageMap = keyof typeof pageMap

export default function mapPage(page: string) {
  return pageMap[page as PageMap]
}
